'use client';

import { InboxCollector, MergedInboxProvider } from './components/MessagesDrawer/MergedInboxProvider';
import { useFlagsProxy } from '@modules/feature-flags/hooks/useFlagsProxy';
import { MessagesDrawer } from 'app/(authenticated)/_components/NavActions/components/MessagesDrawer/MessagesDrawer';

import { CourierProvider } from '@trycourier/react-provider';
import { Toast as CourierToast } from '@trycourier/react-toast';
import React from 'react';

import type { UserInfo } from 'shared/src/user/types';

type Props = Readonly<{
  user: UserInfo;
}>;

export const CourierNotifications: React.FC<Props> = ({ user }) => {
  const { cloudLayoutCourierPush } = useFlagsProxy();

  const courierEnabled = process.env.COURIER_ENABLED === 'true';
  const hasAuth0Courier = courierEnabled && !!user?.sub && !!user?.courierUserHmac;
  const hasEmailCourier = courierEnabled && !!user?.email && !!user?.courierEmailJwt;

  if (!hasAuth0Courier && !hasEmailCourier) {
    return null;
  }

  return (
    <MergedInboxProvider>
      {hasAuth0Courier && (
        <CourierProvider
          userId={user.sub.split('|').pop()}
          userSignature={user.courierUserHmac}
          clientKey={process.env.COURIER_CLIENT_KEY}
        >
          {cloudLayoutCourierPush && <CourierToast />}
          <InboxCollector sourceId='auth0' />
        </CourierProvider>
      )}

      {hasEmailCourier && (
        <CourierProvider
          userId={user.email}
          authorization={user.courierEmailJwt}
          clientKey={process.env.COURIER_CLIENT_KEY}
        >
          {cloudLayoutCourierPush && <CourierToast />}
          <InboxCollector sourceId='email' />
        </CourierProvider>
      )}

      <MessagesDrawer />
    </MergedInboxProvider>
  );
};
